import Popup from "../../utils/popup";
import CartShort from "../../utils/cart-short";
import Tools from "../../utils/tools";
import ListaTowarow from "../towary/listatowarow";

class Towar {
    constructor() {
        this.noTermsInfo = $("#no-terms-info");
        this.eventsList = $("#events-list");
        this.addToCartButton = $("#add-to-cart");
        this.cartShort = new CartShort();
    }

    events() {
        const _this = this;
        $(".js-dodaj-do-koszyka-btn")
            .off("click")
            .on("click", function () {
                if ($(this).hasClass("disabled")) {
                    let popup = new Popup(translates.towar_cyfrowy_info);
                    popup.showPopup();
                    return;
                }
                let towarData = $(".js-ilosc-towaru").data();
                _this.zablokujTowar(towarData);
            });

        $(".product__item").on("click", function () {
            let towarCmsId = $(this).data("towarcms_id");
            document.location.href = "/towary/szczegoly.html?id=" + towarCmsId;
        });

        //$('.js-show-full-image').off('click').on('click', function () {
        //    console.log('test');
        //});

        $(".butik_desc_head__main").magnificPopup({
            delegate: "a", // child items selector, by clicking on it popup will open
            type: "image",
            gallery: {
                enabled: true, // set to true to enable gallery
                preload: [0, 2], // read about this option in next Lazy-loading section
                navigateByImgClick: true,
                arrowMarkup: "<button title=\"%title%\" type=\"button\" class=\"mfp-arrow mfp-arrow-%dir%\"></button>", // markup of an arrow button
                tPrev: translates.strzalka_lewo, // title for left button
                tNext: translates.strzalka_prawo, // title for right button
                tCounter: "<span class=\"mfp-counter\">%curr% / %total%</span>" // markup of counter
            }
        });

        $(".butik_desc_head__main_mob").magnificPopup({
            delegate: "a", // child items selector, by clicking on it popup will open
            type: "image",
            gallery: {
                enabled: true, // set to true to enable gallery
                preload: [0, 2], // read about this option in next Lazy-loading section
                navigateByImgClick: true,
                //arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
                tPrev: translates.strzalka_lewo, // title for left button
                tNext: translates.strzalka_prawo, // title for right button
                tCounter: "<span class=\"mfp-counter\">%curr% / %total%</span>" // markup of counter
            }
        });

        $("#addFav").off("click").on("click", function () {
            if (czyZalogowany > 0) {
                let iksorisTowarId = parseInt($(this).data("iksoris_towar_id"));
                let type = "add";
                if ($(this).hasClass("isfav")) {
                    type = "remove";
                }
                _this.towarPolka(iksorisTowarId, type);
            } else {
                let popup = new Popup(translates.polka_zaloguj);
                popup.onClose = function () {
                    Tools.preloaderShow();
                    window.location.href = logowanieUrl;
                }
                popup.showPopup();
            }
        });

        $(".ts-download-btn").on("click", function () {
            if ($(this).hasClass('niezakupiony')) {
                let popup = new Popup(
                    translates.produkt_niezakupiony
                );
                popup.showPopup();
                return;
            }
            let buttonData = $(this).data();
            let listaTowarowInstance = new ListaTowarow();
            listaTowarowInstance.downloadFile(buttonData);
        });

    }

    towarPolka(towar_iksoris_id, type) {
        const _this = this;
        $.ajax({
            url: "/towary/szczegoly.html",
            method: "get",
            beforeSend: Tools.preloaderShow,
            complete: Tools.preloaderHide,
            data: {
                json: true,
                ajax_action: type === "add" ? "dodaj_na_polke" : "usun_z_polki",
                towar_iksoris_id: towar_iksoris_id
            },
            success: function (result) {
                if (result && result.status === "complete") {
                    if (jQuery.inArray(towar_iksoris_id, result.towaryIdNaPolce) !== -1) {
                        $("#addFav")
                            .addClass("isfav")
                            .text(translates.usunZUlubionychKomunikat);
                    } else {
                        $("#addFav")
                            .removeClass("isfav")
                            .text(translates.dodajDoUlubionychKomunikat);
                    }
                    let popup = new Popup(result.successMessage);
                    popup.showPopup();
                } else {
                    let popup = new Popup(
                        result.message ||
                        "Wystąpił błąd podczas dodawania towaru na półkę"
                    );
                    popup.showPopup();

                }
            },
            error: function (xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    zablokujTowar(params) {
        const _this = this;
        params.json = true;
        params.ajax_action = "zablokuj_towar";
        params.ilosc = parseInt($(".js-ilosc-towaru").val());

        $.ajax({
            url: "/towary/szczegoly.html",
            method: "get",
            data: params,
            beforeSend: Tools.preloaderShow,
            complete: Tools.preloaderHide,
            success: function (result) {
                if (result && result.status === "complete") {
                    let popup = new Popup(
                        result.successMessage || "Towar dodany do koszyka"
                    );

                    popup.onClose = function () {
                        $(".js-ilosc-towaru").val(1);
                    };

                    popup.showPopup();

                    // Dezaktywacja przycisku "Dodaj do koszyka"
                    if (result.dostepnaIlosc === 0) {
                        _this.setAddToCartButtonDisabled();
                    }

                    // Aktualizacja podsumowania koszyka (popup w prawym górnym rogu menu - .fr-cart-short)
                    _this.cartShort.data = result.data;

                    if (
                        result.towarCyfrowy &&
                        (result.wKoszyku || result.zakupiony)
                    ) {
                        $("#add-to-cart").attr({
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            title: translates.towar_cyfrowy_info,
                            "data-original-title": translates.towar_cyfrowy_info
                        }).addClass("disabled");
                        $("[data-toggle=\"tooltip\"]").tooltip();
                    }
                } else {
                    let popup = new Popup(
                        result.message ||
                        "Wystąpił błąd podczas dodawania towaru do koszyka"
                    );
                    if (result.redirectUrl) {
                        popup.onClose = function () {
                            window.location.href = result.redirectUrl;
                        };
                    }
                    popup.showPopup();

                    // Dezaktywacja przycisku "Dodaj do koszyka"
                    if (result.dostepnaIlosc === 0) {
                        _this.setAddToCartButtonDisabled();
                    }
                }
            },
            error: function (xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    matchBoxesHeight() {
        $(".product__item").matchHeight({
            byRow: true,
            property: "height",
            target: null,
            remove: false
        });
    }

    initSlickForImages() {
        $(".butik_desc_head__main_mob").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            prevArrow:
                "<button type=\"button\" class=\"slick-prev\"><img src=\"/assets/images/arrow.png\"></button>",
            nextArrow:
                "<button type=\"button\" class=\"slick-next\"><img src=\"/assets/images/arrow.png\"></button>"
            //asNavFor: '.butik_desc_head__main_mob',
        });
    }

    // Dezaktywacja przycisku "Dodaj do koszyka"
    setAddToCartButtonDisabled() {
        this.addToCartButton.addClass("btn--disabled");
    }

    init() {
        this.events();
        this.matchBoxesHeight();
        if ($("body").hasClass("mobile")) {
            this.initSlickForImages();
        }

        $("[data-toggle=\"tooltip\"]").tooltip();
    }
}

export default Towar;
